class LoaderExternalInterface {
	constructor(store, base) {
		this.appLoaded = false;
		this.base = base;
		this.store = store;
	}
	getApplicationLoaded() {
		return this.appLoaded;
	}
	GetTotal() { // eslint-disable-line
		return 5;
	}
	GetScore() {
		return Math.round(this.store.getState().exercise.wordsRecognisedPercent / 20);
	}
	getBase() {
		return this.base;
	}
}

export default LoaderExternalInterface;
